module.exports = __webpack_public_path__ + "static/media/Nardie-Scharenborg-CTO-CIO-SSCICT-feedback.01a6aab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Nardie-Scharenborg-CTO-CIO-SSCICT-feedback.png
// module id = 190
// module chunks = 0